import React from 'react';

const AboutTora = (about) => {
  const lineUrl    ='';
  const contactUrl = `/contact/${about.type}`;

  return(
  <div>
    {about.hideDesc && about.hideDesc == 1 &&
    <div className='fs-sm mb-3'>{about.item.desc}</div>
    }
    <div className='fs-sm font-weight-bold mb-1'>お問い合わせはお気軽に</div>
    <div className='mb-2'>
      <a href={lineUrl} className='btn btn-block btn-sns btn-sm btn-line'>
        <img src="https://tora-tora.net/themes/travel/dev/images/icon/sns-line.png"
             alt="LINE"/> LINEでお問い合わせ
      </a>
    </div>
    <div className='mb-2'>
      <a href={contactUrl} className='btn btn-block btn-success btn-sm text-white'>
        <i className="fa fa-envelope-open" aria-hidden="true"></i> メールでお問い合わせ
      </a>
    </div>
    <div className='mt-4 mb-3'>
      {about.notice}
    </div>

    {about.hideContact && about.hideContact == 1 &&
    <div>
      <div className='mb-3'>
        日本からはこちら<br className='hidden-sm-up'/>
        <span><a className='text-success fw-b' href="tel:05068647099"> 050-6864-7099</a></span><br/>
        オーストラリアから<br className='hidden-sm-up'/>
        <span><a className='text-success fw-b' href="tel:0292863774"> 02-9286-3774</a></span>
      </div>

      <div>
        月-金：10am-18pm<br/>
        土：11am-16pm<br/>
        日：定休日
      </div>
    </div>
    }
  </div>
  )
};

export default AboutTora;



// WEBPACK FOOTER //
// ./src/pages/about/components/AboutTora.js